var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"pa-1",attrs:{"no-gutters":""}},_vm._l((_vm.items),function(item){return _c('v-col',{key:item,staticClass:"pa-1",attrs:{"cols":"12","sm":"6","lg":"4"}},[_c('heirloom-item',{attrs:{"name":item}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }